import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import DeleteModal from "../../../Layout/Components/DeleteModal";
import AbsenModal from "../components/AbsenModal";
import { Button, Label } from "reactstrap";
import { Edit2, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import { getLokasi } from "../utils/getLokasi";
import { PERMISSIONS } from "../../../Constant/FeatureSelection";
import { useContext } from "react";
import RoleContext from "../../../Context/RoleContext";
import { useAbsensi } from "../../../Context/AbsensiContext";

const AbsenColumns = (resetState, dateFilter) => {
  const absensiAPI = useAbsensi();
  const { checkPermission } = useContext(RoleContext);
  return [
    {
      name: <DataTableTitle text={"Nama Grup"} />,
      selector: (row) => row.group_nama,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Nama Staf"} />,
      selector: (row) => row.nama,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Lokasi Terakhir"} />,
      selector: (row) => getLokasi(row.datang, row.pulang),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Datang"} />,
      selector: (row) => row.datang?.jam ?? "",
      width: "15%",
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Pulang"} />,
      selector: (row) => row.pulang?.jam ?? "",
      width: "15%",
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Operasi"} />,
      width: "30%",
      cell: (row) => (
        <div className="row row-cols-3 w-100">
          {checkPermission(PERMISSIONS.ADD_ABSENSI) && <Link
            to={`/absen/${row.id}/bulanan`}
            className="p-0 d-flex align-items-center justify-content-center btn-light text-success"
            style={{ cursor: "pointer" }}
          >
            <Edit2 size={12} />
            <Label className="p-0 m-0" style={{ cursor: "pointer" }}>
              Absen
            </Label>
          </Link>}
          {
            (checkPermission(PERMISSIONS.ADD_ABSENSI) || checkPermission(PERMISSIONS.CHANGE_ABSENSI)) && (
              <AbsenModal
                create={false}
                row={row}
                dateFilter={dateFilter}
                resetState={resetState}
              />
            )
          }
          {checkPermission(PERMISSIONS.DELETE_ABSENSI) && row.absen && (
            <DeleteModal
              name={"absensi"}
              CustomButton={({ toggle }) => (
                <Button
                  className={
                    "p-0 d-flex align-items-center justify-content-center btn-light text-danger"
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    toggle();
                  }}
                >
                  <Trash2 size={12} />
                  Delete
                </Button>
              )}
              axiosDelete={absensiAPI.deleteAbsensi}
              pk={row.absen?.id_absensi}
              resetState={resetState}
            />
          )}
        </div>
      ),
    },
  ];
};

export default AbsenColumns;
